/*
 * @Author: FengXiao
 * @Date: 2020-07-01 22:19:22
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-08-29 10:03:29
 */

import axios from './config';

const DEFAULT_CONFIG = {
  printMsg: true,
};
function requestApi(url, data, method = 'GET', headerConfig = {}, otherConfig) {
  const headers = Object.assign({}, headerConfig);
  let conf = {
    url,
    method,
    headers,
  };
  if (method === 'GET') {
    conf.params = data;
  } else {
    conf.data = data;
  }
  Object.assign(conf, DEFAULT_CONFIG);
  if (otherConfig) {
    Object.assign(conf, otherConfig);
  }
  return axios(conf);
}

export default requestApi;
